import { ref } from '@nuxtjs/composition-api';
import useFetchProducts from '@/composables/useFetchProducts';
import useFetchFaqs from '@/composables/useFetchFaqs';
import useFetchDocuments, {
  DocumentItem,
} from '@/composables/useFetchDocuments';
import type { Product, Params } from '@webplatform/nuxt-cms-js-sdk';

type FetchProductParams = Params & {
  slug: string;
};

type ContentBlock = {
  type: string;
  data: Record<string, any> | Record<string, any>[] | string[];
};

const NO_RICH_TYPES = ['short_description', 'tags', 'category-recommended'];

const useProductPage = () => {
  const { fetchProductBySlug } = useFetchProducts();
  const { faqs, fetchFaqs } = useFetchFaqs();
  const { documents, fetchDocuments, DOCUMENT_TYPES } = useFetchDocuments();
  const product = ref<Product>();
  const productContent = ref<ContentBlock[]>();

  const fetchProduct = async (params: FetchProductParams) => {
    try {
      const { slug, ...queryParams } = params;
      const data = await fetchProductBySlug(slug, queryParams);

      if (!data) return;

      await fetchFaqs((data as any).id);
      await fetchDocuments(
        { product_sku: (data as any).sku },
        {
          videos: [DOCUMENT_TYPES.VIDEOS],
          manuals: {
            exclude: [DOCUMENT_TYPES.SOFTWARE],
          },
        },
      );

      data.faqs = faqs.value;
      data.documents = documents.value as Record<string, DocumentItem[]>;

      productContent.value = (data as any).content?.filter(
        ({ type }: { type: any }) => !NO_RICH_TYPES.includes(type),
      );

      (product as any).value = data;
    } catch (e) {}
  };

  return {
    product,
    productContent,
    fetchProduct,
  };
};

export default useProductPage;
